import React, { createContext, useContext, useState } from "react";

const CustomerAuthContext = createContext();

export const CustomerAuthProvider = ({ children }) => {
  const [customerToken, setCustomerToken] = useState(() => localStorage.getItem("customerToken"));

  const login = (token) => {
    localStorage.setItem("customerToken", token);
    setCustomerToken(token);
  };

  const logout = () => {
    localStorage.removeItem("customerToken");
    setCustomerToken(null);
  };

  const isAuthenticated = !!customerToken;

  return (
    <CustomerAuthContext.Provider value={{ customerToken, login, logout, isAuthenticated }}>
      {children}
    </CustomerAuthContext.Provider>
  );
};

export const useCustomerAuth = () => useContext(CustomerAuthContext);
